import { isPlatformServer } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AssetService } from 'src/app/services/asset.service';
import { GalleryService } from 'src/app/services/gallery.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryAssetVersionResolve {
  constructor(
    private assetService: AssetService,
    private galleryService: GalleryService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  private async getAsset(assetId: string, galleryId: string) {
    try {
      return await this.assetService.getAsset(assetId, galleryId);
    } catch (err) {
      if (!(err instanceof HttpErrorResponse)) throw err;
    }
  }

  async resolve(route: ActivatedRouteSnapshot) {
    if (isPlatformServer(this.platformId)) return { asset: undefined, versions: [] };
    const gallery = await this.galleryService.getPublicGalleryFromSnapshot(route, { isPublic: true });
    const assetId = route.params.assetId.replace('}', '');
    const [asset, versions] = await Promise.all([
      this.getAsset(assetId, gallery.id),
      this.assetService.getAssetVersions(assetId, gallery.id),
    ]);

    const version = versions.find(v => v.id === route.params.versionId);

    return { asset, versions, version };
  }
}
